import { Banner, Button, LoadingWand, SearchBar } from '@ordr-as/umami-react'
import CreatePaymentMethodDialog from 'components/CreatePaymentMethodDialog'
import { usePaymentMethods } from 'hooks/usePaymentMethodApi'
import OverviewPageTemplate from 'pages/OverviewPageTemplate'
import { useEffect, useState } from 'react'
import { PaymentMethodDto } from '../../../generated-api'
import PaymentMethodList from './PaymentMethodList'

const PaymentMethodsOverview = () => {
    const [filteredPaymentMethods, setFilteredPaymentMethods] = useState<PaymentMethodDto[]>([])
    const [searchQuery, setSearchQuery] = useState<string>('')
    const [createDialogIsOpen, setCreateDialogIsOpen] = useState(false)

    const { data: paymentMethods, isLoading, isSuccess, isError, error } = usePaymentMethods()

    useEffect(() => {
        if (!paymentMethods) {
            return
        }

        const trimmedSearchQuery = searchQuery.trim()
        const searchQueryLowerCase = trimmedSearchQuery.toLowerCase()

        const filtered = paymentMethods.filter((pm) => {
            return (
                pm.paymentProvider.toLowerCase().includes(searchQueryLowerCase) ||
                pm.paymentMethod.toLowerCase().includes(searchQueryLowerCase)
            )
        })

        setFilteredPaymentMethods(filtered)
    }, [paymentMethods, searchQuery])

    return (
        <OverviewPageTemplate heading="Payment methods">
            {isLoading && <LoadingWand className="mx-auto" />}

            {isError && (
                <Banner kind="error" onClose={() => null} stretch="parent" className="my-3">
                    {(error as Error).message}
                </Banner>
            )}

            {isSuccess && (
                <div className="py-2 max-w-full">
                    {paymentMethods.length === 0 ? (
                        <div className="flex flex-col gap-4">
                            <Banner kind="warn" stretch="parent" onClose={() => null}>
                                There are no payment methods
                            </Banner>
                            <Button kind="primary" onClick={() => setCreateDialogIsOpen(true)}>
                                Create Payment Method
                            </Button>
                        </div>
                    ) : (
                        <>
                            <div className="mb-4 flex gap-2">
                                <SearchBar
                                    value={searchQuery}
                                    placeholderText="Search payment provider or payment method"
                                    aria-label="Search payment provider or payment method"
                                    setValue={(text) => setSearchQuery(text)}
                                    setActive={() => null}
                                    fullWidth
                                />
                                <Button kind="primary" onClick={() => setCreateDialogIsOpen(true)}>
                                    Create Payment Method
                                </Button>
                            </div>

                            <PaymentMethodList paymentMethods={filteredPaymentMethods} />
                        </>
                    )}
                </div>
            )}

            <CreatePaymentMethodDialog dialogIsOpen={createDialogIsOpen} onClose={() => setCreateDialogIsOpen(false)} />
        </OverviewPageTemplate>
    )
}

export default PaymentMethodsOverview
